import type { SsoLogin } from '../actions';

type Response = {
  code: string;
  existingAccountType?: string;
  prefillEmail?: string;
};

type Service = 'apple' | 'facebook' | 'google';

class SSOError extends Error {
  declare code: string;

  declare response: Response;

  declare service: Service;

  constructor(response: Response = { code: '' }, service: $TSFixMe) {
    const { code = '' } = response;

    super(code);

    this.code = code;
    this.response = response;
    this.service = service;
  }
}

type InvalidDomainSSOErrorOptions = {
  ssoLoginResponse?: SsoLogin;
  showResendLink?: boolean;
  isSSOLockedOut?: boolean;
  prefillEmail?: string;
  token?: string;
};

class InvalidDomainSSOError extends SSOError {
  declare ssoLoginResponse?: SsoLogin;

  declare showResendLink?: boolean;

  declare isSSOLockedOut?: boolean;

  declare token?: string;

  constructor({
    ssoLoginResponse,
    showResendLink,
    isSSOLockedOut,
    prefillEmail,
    token,
  }: InvalidDomainSSOErrorOptions = {}) {
    super({ code: 'invalidDomain', prefillEmail }, undefined);

    this.showResendLink = showResendLink;
    this.isSSOLockedOut = isSSOLockedOut;
    this.ssoLoginResponse = ssoLoginResponse;
    this.token = token;
  }
}

export { InvalidDomainSSOError };
export default SSOError;
